
<template>
  <div>
  <div style="margin-top:0px;margin-left: 20px;margin-right: 20px;margin-top: 10px">
    <div style="padding-left: 20px;padding-top: 5px;padding-bottom: 10px;
      font-weight: bold;background-color:#eef1f6 "><a style="font-size: 1.4rem;margin: 0;color: black"></a>
      <a style="font-size: 1.3rem;margin: 0">RNA about {{input}}</a></div>

    <div style="padding: 5px;border: 2px solid #eef1f6">
      <el-row :gutter="1">

        <el-col :span="12">
         <el-row :gutter="1">
        <el-col :span="4" style="margin-left: 20px"><a style="font-size: 1.1rem;font-weight: bold;color: black">RNA:</a></el-col>
        <el-col :span="18"><a style="font-size: 1rem;color: #606266">{{input}}</a></el-col>
      </el-row>

          <el-row :gutter="1">
            <el-col :span="4" style="margin-left: 20px"><a style="font-size: 1.1rem;font-weight: bold;color: black">Type:</a></el-col>
            <el-col :span="18"><a style="font-size: 1rem;color: #606266">{{other.type}}</a></el-col>
          </el-row>
          <el-row :gutter="1">
            <el-col :span="4" style="margin-left: 20px"><a style="font-size: 1.1rem;font-weight: bold;color: black">Species:</a></el-col>
            <el-col :span="18"><a style="font-size: 1rem;color: #606266">{{other.species}}</a></el-col>
          </el-row>

         <el-row :gutter="1">
        <el-col :span="4" style="margin-left: 20px"><a style="font-size: 1.1rem;font-weight: bold;color: black">Description:</a></el-col>
        <el-col :span="18"><p style="font-size: 1rem;color: #606266" >{{other.description}}</p></el-col>
      </el-row>

         <el-row :gutter="1" style="margin-top: 0px">
        <el-col :span="4" style="margin-left: 20px;font-size: 0"><p style="font-size: 1.1rem;font-weight: bold;color: black;margin-top: 0px">Molecular function
          :</p></el-col>
        <el-col :span="18" style="font-size: 0"><a class="go"  v-for="(item,index) in other.go_terms" style="font-size: 1rem;color: #606266">{{item+(index===other.go_terms.length -1?'':';'+'\n')}}</a></el-col>
      </el-row>

         <el-row :gutter="1" style="margin-bottom: 0px">
        <el-col :span="4" style="margin-left: 20px"><p style="font-size: 1.1rem;font-weight: bold;color: black;margin-top: 14px">Subcellular location:</p></el-col>
        <el-col :span="18"><p style="font-size: 1rem;color: #606266">{{other.rna_locate}}</p></el-col>
      </el-row>

          <el-row :gutter="1" style="margin-bottom: 0px">
            <el-col :span="4" style="margin-left: 20px"><p style="font-size: 1rem;font-weight: bold;color: black">MIM number:</p></el-col>
            <el-col :span="18"><a v-show="other.mimid!='-'" style="font-size: 1rem;color: #0e63bb" :href='"https://omim.org/entry/"+other.mimid' target="_blank" >{{other.mimid}}</a>
              <a v-show="other.mimid=='-'" style="font-size: 1rem;color: #0e63bb">{{other.mimid}}</a></el-col>
          </el-row>

          <el-row :gutter="1" style="margin-bottom: 10px">
            <el-col :span="4" style="margin-left: 20px"><p style="font-size: 1.1rem;font-weight: bold;color: black;margin-top: 0px">Disease:</p></el-col>
            <el-col :span="18" style="font-size: 0px"><a class="go"  v-for="(item,index) in other.disease" style="font-size: 1rem;color: #606266">{{item+(index===other.disease.length -1?'':'),'+'\n')}}</a></el-col>
          </el-row>
        </el-col>

        <el-col :span="12">
          <el-row><a style="font-size: 1.1rem;font-weight: bold;color: black">Interaction neighbours:</a></el-row>
          <el-row v-show="category.length==0" style="font-size: 0.8rem"><div>-</div></el-row>
          <el-row v-show="category.length>0" style="height: 600px;font-size: 0.8rem"><div id="main" style="width: 100%;height:100%;"></div></el-row>
        </el-col>

      </el-row>

      <el-table
          :data="tableData.slice((currpage - 1) * pagesize, currpage * pagesize)"
          @sort-change="sort_change"
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'0.9rem'}"
          :cell-style="{fontSize: '0.9rem'}"
          stripe
          highlight-current-row
          border

      >
        <el-table-column
            prop="Psid"
            label="RPSID"
            align= "center"
            sortable

        >
          <template slot-scope="scope">
            <router-link  target="_blank" v-bind:to="/Detail/+scope.row.Psid">{{scope.row.Psid}}</router-link>
          </template>

        </el-table-column>

        <el-table-column
            prop="Nucleic_acid"
            label="RNA(s)"
            align= "center"
            sortable

        >
        </el-table-column>
        <el-table-column
            prop="RNA_len"
            label="RNA length"
            align= "center"
            sortable
        >
          <template slot-scope="scope">
            <a style="color: #606266">{{scope.row.RNA_length}}</a>
          </template>
        </el-table-column>
        <el-table-column
            prop="Rna_classification"
            label="RNA type"
            align= "center"
            sortable
        >

        </el-table-column>
        <el-table-column
            prop="Rna_source"
            label="RNA species"
            align= "center"
            sortable

        >
        </el-table-column>
        <el-table-column
            prop="Protein_name"
            label="Protein name"
            align= "center"
            sortable
        >

        </el-table-column>
        <el-table-column
            prop="Components_type"
            label="Component type"
            align= "center"
            sortable
        >

        </el-table-column>
        <el-table-column
            prop="Vivo_or_vitro"
            label="Vivo/vitro"
            align= "center"
            sortable

        >
        </el-table-column>


      </el-table>
      <div style="padding: 6px"></div>
      <el-pagination background
                     layout="prev, pager, next, sizes, total, jumper"
                     :page-sizes="[5, 10, 15, 20]"
                     :page-size="pagesize"
                     :current-page="currpage"
                     :total="tableData.length"
                     small
                     @current-change="handleCurrentChange"
                     @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>
  </div>
  </div>
</template>

<script>
import {getsearch,getrnainter,getrnaother} from "@/network/Search";

export default {
  name: "SearchResult",
  data() {
    return {
      tableData: [],
      other:[],
      input:null,
      pagesize:10,
      currpage:1,
      proptype: "",
      interdata:[],
      interlinks:[],
      category:[],
      category2:[],
    }
  },

  mounted:function () {
    this.timer = setTimeout(()=>{   //设置延迟执行
      this.drawLine()
    },600);
  },

  created() {
    this.input=this.$route.params.input
    getsearch(this.input).then(res => {
      let a=res.list
      let arr=[]
      for (let i=0;i<a.length;i++){
        let obj={}
        obj.Psid=a[i].fields.rpsid
        obj.Nucleic_acid=a[i].fields.rnas.split('|').join('\n')
        obj.Components_type=a[i].fields.components_type
        obj.RNA_len=a[i].fields.rnalenub
        obj.RNA_length=a[i].fields.rna_length.split('|').join('\n')
        obj.Protein_name=a[i].fields.protein_name.split('|').join('\n')
        obj.Rna_source=a[i].fields.source.split('|').join('\n')
        obj.Rna_classification=a[i].fields.rna_classification.split('|').join('\n')
        obj.Vivo_or_vitro=a[i].fields.in_vitrovivo
        arr.push(obj)
      }for (var i = 0; i < arr.length - 1; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i].Psid == arr[j].Psid) {
            arr.splice(j, 1);
            //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
            j--;
          }
        }
      }
      this.tableData=arr
    })
    getrnaother(this.input).then(res => {
      let a = res.list
      console.log(a)
      if (a.length==0){
        let obj={}
        obj.rna='-'
        obj.type='-'
        obj.species='-'
        obj.description='-'
        obj.go_terms='-'
        obj.rna_locate='-'
        obj.mimid='-'
        obj.disease='-'
        obj.RNA_len='-'

        this.other=obj
      }else {
        let obj={}
        obj.rna=a[0].fields.rnas
        obj.type=a[0].fields.type
        obj.species=a[0].fields.rna_classification
        obj.mimid=a[0].fields.mimid
        obj.RNA_len=a[0].fields.rnalenub
        obj.disease=a[0].fields.disease.split('),')
        obj.description=a[0].fields.rna_description
        obj.go_terms=a[0].fields.go_terms.split(';')
        obj.rna_locate=a[0].fields.rna_locate
        this.other=obj
      }
    })
    getrnainter(this.input).then(res => {
      let a=res.list
      let arr1=[]
      let arr2=[]
      let arr3=[]
      let arr4=[]
      let obj1={}
      let obj2={}

      for (let i=0;i<a.length;i++){
        let obj1={}
        obj1.name=a[i].fields.rnastwo
        obj1.category=a[i].fields.typetwo
        arr1.push(obj1)
      }
      obj1.name=a[0].fields.rnasone
      obj1.category=a[0].fields.typeone

      arr1.push(obj1)

      for (var i = 0; i < arr1.length - 1; i++) {
        for (var j = i + 1; j < arr1.length; j++) {
          if (arr1[i].name == arr1[j].name) {
            arr1.splice(j, 1);
            //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
            j--;
          }
        }
      }

      for (let i=0;i<a.length;i++){
        let obj={}
        obj.source=a[0].fields.rnasone
        obj.target=a[i].fields.rnastwo
        obj.score=a[i].fields.score
        arr2.push(obj)
      }
      this.interlinks=arr2

      for (let i=0;i<a.length;i++){
        let obj={}
        obj.name=a[i].fields.typetwo
        arr3.push(obj)
      }
      obj2.name=a[0].fields.typeone
      arr3.push(obj2)

      for (var i = 0; i < arr3.length - 1; i++) {
        for (var j = i + 1; j < arr3.length; j++) {
          if (arr3[i].name == arr3[j].name) {
            arr3.splice(j, 1);
            //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
            j--;
          }
        }
      }
      this.category=arr3

      for (let i=0;i<arr3.length;i++){
        let obj
        obj=arr3[i].name
        arr4.push(obj)
      }
      this.category2=arr4

      for(var i = 0; i < arr1.length - 1; i++){
        for(var j=0; j< arr3.length - 1; j++){

          if (arr1[i].category==arr3[j].name){
                  arr1[i].category=j
          }
        }
      }

      this.interdata=arr1

    })
  }
  ,

  methods:{
    drawLine(){
      let myChart = this.$echarts.init(document.getElementById('main'))
      myChart.setOption( {
        title: {
          left: 'center'
        },
        //
        // },
        // toolbox: {
        //   // 显示工具箱
        //   show: true,
        //   feature: {
        //     mark: {
        //       show: true
        //     },
        //     // 还原
        //     restore: {
        //       show: true
        //     },
        //     // 保存为图片
        //     saveAsImage: {
        //       show: true
        //     }
        //   }
        // },
        //
        legend: [{
          // selectedMode: 'single',
          x:'left',
          data: this.category2
        }],
        animationDuration: 1000,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            type: 'graph', // 类型:关系图
            layout: 'circular', //图的布局，类型为力导图
            symbolSize: 10, // 调整节点的大小
            focusNodeAdjacency: true,
            legendHoverLink : true,
            draggable : true,
            width:'100%',
            height:'55%',
            circular: {
              rotateLabel: true
            },
            force : {
              repulsion : 100,//节点之间的斥力因子。支持数组表达斥力范围，值越大斥力越大。
              gravity : 0.03,//节点受到的向中心的引力因子。该值越大节点越往中心点靠拢。
              edgeLength :80,//边的两个节点之间的距离，这个距离也会受 repulsion。[10, 50] 。值越小则长度越长
              layoutAnimation : false,
            },

            label: {
                silent:true,
                show:true
            },

            edgeLabel: {
              emphasis: {
                show: true,
                color:'black',
                formatter: function (x) {
                  return 'score:'+x.data.score;
                }
              }
            },

            lineStyle: {
              color: 'target',
              curveness: 0.2
            },

            emphasis: {
              focus:'adjacency',
              lineStyle: {
                width: 10
              }
            },
            roam: true,
            data:this.interdata,
            links:this.interlinks,
            categories:this.category,

          }
        ]
      });
    },

    sort_change(column) {
      this.currpage = 1; // 排序后返回第一页
      this.proptype = column.prop; // 将键名prop赋值给变量proptype
      if (column.order === "descending") {
        this.tableData.sort(this.my_desc_sort);
      } else if (column.order === "ascending") {
        this.tableData.sort(this.my_asc_sort);
      }
    },
    //排序方法
    my_desc_sort(a, b) {
      if (a[this.proptype] > b[this.proptype]) {
        return -1
      } else if (a[this.proptype] < b[this.proptype]) {
        return 1
      } else {
        return 0
      } // a["time"] 等价于 a.time
    },
    my_asc_sort(a, b) {
      if (a[this.proptype] > b[this.proptype]) {
        return 1
      } else if (a[this.proptype] < b[this.proptype]) {
        return -1
      } else {
        return 0
      }
    }
    ,
    handleCurrentChange(cpage) {
      this.currpage = cpage;
    },
    handleSizeChange(psize) {
      this.pagesize = psize;
    }
  }
}

</script>

<style scoped>
a {
  text-decoration: none;
  color: #0e63bb;
}

.go{
  white-space: pre-wrap;
  padding-bottom: 0px;
}

</style>